import React, { useCallback, useState, useRef, useEffect, useMemo } from 'react';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import { GridLayout } from "../../../../../../common/GridLayout";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import data from "../../../../../../assets/apiRoutes.json";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Editing
} from "devextreme-react/data-grid";
import { GetFormatedDateWithTime } from '../../../../../../common/Utils'
import FormField from '../../../../../../dynamicFormBuilder/FormField'
import GridLayoutManager from "../../../../../../gridLayoutCustomization/GridLayoutManager";
import { alert } from 'devextreme/ui/dialog';
import { WarrantyFlagShipment, WeightBasis } from '../../../../../../enum/Enum';
import { MESSAGES } from '../../../../../../common/Messages';
import { LoadPanel } from 'devextreme-react/load-panel';
import { collectShipExpirationRejections } from './shipExpirationCheck';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];


const ManuallySelectSublotsAndLotsForShipment = (props) => {
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [selectedRows, setSelectedRows] = useState(null);
    const position = { of: '#accordion-containe2' };
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [showIndicator, setShowIndicator] = useState(true);
    const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
    const [shading, setShading] = useState(true);
    const [showPane, setShowPane] = useState(true);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const dataGrid = useRef(null);
    const gridKey = "6124fd64-515d-452e-b4fc-5389be216ca2";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        ItemCode: "",
        ItemType: "Item Lot Sublot",
        TotalQuantity: 0,
        TotalNetWeight: 0
    };
    const [formFields, setformFields] = useState(initialFormFields);
    // Sublot shipment expiration / warranty guard, run as each row is ticked and clearing the tick
    // when the row is refused - the same point and the same effect as Delphi, which sets
    // Selected := 0 (uWMD0109.pas:364-396). The server re-checks on save as the backstop.
    //
    // The shared helper reads WarrantyFlagShipment off the row; this grid's DTO names that column
    // WarrantyFlagShipmentItem, so the rows are re-shaped for the call. Spreading keeps the grid key.
    const onSelectionChanged = async (e) => {
        const { selectedRowsData, currentSelectedRowKeys } = e;

        const newlySelected = currentSelectedRowKeys?.length
            ? (selectedRowsData ?? []).filter((row) => currentSelectedRowKeys.includes(row.SublotRowId))
            : [];

        if (newlySelected.length) {
            const rejected = await collectShipExpirationRejections({
                rows: newlySelected.map((row) => ({ ...row, WarrantyFlagShipment: row.WarrantyFlagShipmentItem })),
                keyOf: (row) => row.SublotRowId,
                labelOf: (row) => row.SublotCode,
                expiryOf: (row) => row.DateExpirationSublot,
                shipDate: props.ShipDate,
                expectedFlag: WarrantyFlagShipment.UseSublotExpirationDate,
            });

            if (rejected.length) {
                // deselectRows re-enters this handler, which recalculates the totals from what survives.
                e.component.deselectRows(rejected);
                return;
            }
        }

        if (selectedRowsData) {
            setSelectedRows(selectedRowsData);
            calculateWeights(selectedRowsData);
        }
    };
    const calculateWeights = (selectedRows) => {
        if (selectedRows) {
            // Assume selectedRows is an array of selected row objects
            let lShipQuantity = 0;
            let lShipWeight = 0;

            selectedRows.forEach(row => {
                lShipQuantity += row.TransferQuantity || 0;
                if (row.WeightBasisFlag === WeightBasis.Item) {
                    lShipWeight += (row.TransferQuantity || 0) * (row.NetWeightQuantityItem || 0);
                } else if (row.WeightBasisFlag === WeightBasis.Lot) {
                    lShipWeight += (row.TransferQuantity || 0) * (row.NetWeightQuantityLot || 0);
                } else {
                    lShipWeight += (row.TransferQuantity || 0) * (row.NetWeightQuantitySublot || 0);
                }
            });

            if (formRefs.current) {
                formRefs.current['TotalQuantity'].instance().option('value', lShipQuantity);
                formRefs.current['TotalNetWeight'].instance().option('value', lShipWeight);
            }
        }
    }
    const handelOkClick = async () => {
       const grid = dataGrid.current.instance();

        // Commit whatever cell is still open into editing.changes. Deliberately NOT saveEditData():
        // that pushes the batch through the store, and DevExtreme then RELOADS the DataSource
        // (editing.refreshMode defaults to 'full'). The reload re-runs the store's load, and the
        // endpoint hands back TransferQuantity = SublotAvailable - so the quantity the user typed was
        // silently replaced by Available before it ever reached the payload.
        grid.closeEditCell();

        // The pending batch edits are the ONLY place the typed Ship Quantity lives, because nothing
        // is persisted per row - the picked rows go out in one request below. Merge them over the
        // selected rows so the payload carries what the user entered.
        const pendingEdits = grid.option('editing.changes') ?? [];
        const editedByKey = new Map(
            pendingEdits.filter((c) => c && c.data).map((c) => [c.key, c.data])
        );
        const selected = grid
            .getSelectedRowsData()
            .map((row) => ({ ...row, ...(editedByKey.get(row.SublotRowId) ?? {}) }));
        if (selected.length == 0) {
            alert(MESSAGES.NO_ROW_SELECTED, MESSAGES.ERROR, 2000);
            return;
        }

        setLoadPanelVisible(true);
        const payload = selected.map((row) => {
            const qty = row.TransferQuantity ?? 0;
            return {
                RTransactiondetail: props.rTransactionDetail,
                RItem: props.ItemId,
                RLot: row.LotRowId,
                RSublot: row.SublotRowId,
                Quantityactual: qty,
                RTransactionHeader: props.transactionHeaderId,
                RLocation: row.LocationRowId,
                RWarehouse: row.LocationRWarehouse,
                // The expiration approval was already collected per row on selection, so the save
                // posts IgnoreWarnings = true and the server only blocks a hard stop.
                IgnoreWarnings: true
            };
        });
        try {
            const response = await fetch(
                `${window._env_.REACT_APP_APIS}/WM/TransactionDetailOperations/ApplyManualSublotAndLotSelection`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",  
                        Authorization: `Bearer ${accessToken}`,
                    },
                    body: JSON.stringify(payload),  
                }
            );
            setLoadPanelVisible(false);
            if (!response.ok) 
            {
                var error = await response.text()
                alert(error, MESSAGES.ERROR);
                return;
            }
            const result = await response.json();
            if (result.success)
            {
                props.handleManuallySelectSublotsAndLotsForShipmentSave();
            }
            else
            {
                alert(result.message, MESSAGES.ERROR);
            }
        } 
        catch (error) {
            console.error(error.message, error);
            setLoadPanelVisible(false);
        }
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );


    useEffect(() => {
        setformFields((prevFields) => ({
            ...prevFields,
            ItemCode: props.ItemCode
        }));
    }, [props.ItemCode]);

    // props.ShipDate is a Date OBJECT (DetailsTab passes ACTUALRECEIVEDSHIPPEDDATETIME ??
    // TRANSACTIONDATE, and form.js assigns `new Date()` to those). As a useMemo dependency it would
    // compare by REFERENCE, so a fresh Date on any parent render would rebuild the store and reload.
    // The formatted string compares by value - and it is the shape the API expects anyway, rather than
    // a browser-locale "Tue Aug 26 2026 ..." in the query.
    const shipDate = GetFormatedDateWithTime(props.ShipDate);

    // The rows are owned by a DevExtreme DataSource instead of React state. DevExtreme then holds the
    // "No data" text back and shows its own load indicator for exactly as long as the store's load
    // promise is pending. Nothing here calls setState during the fetch, so there is no re-render -
    // which is why this cannot flicker the way the isLoading / beginCustomLoading version did on this
    // screen (each flip re-rendered the accordion header, which re-created FormField).
    //
    // loadMode 'raw' is the important part: DevExtreme pulls the whole set once and then filters,
    // sorts, groups and pages it CLIENT-side, exactly as the plain array did. So getVisibleRows() and
    // the "all records selected" check in handelOkClick behave unchanged.
    // Holds the rows the store last returned. DevExtreme caches that same array under
    // loadMode 'raw', so patching a row object here keeps the grid's cache and the store in step.
    const loadedRows = useRef([]);

    const sublotDataSource = useMemo(() => new DataSource({
        store: new CustomStore({
            // The grid takes its key from here now. It has to be a real column: without it DevExtreme
            // invents a key per row, and currentSelectedRowKeys / deselectRows / editing.changes[].key
            // would all carry row objects instead of ids - the expiration guard could not clear a
            // rejected tick, and the batch-edit lookup keyed on SublotRowId would never match.
            key: 'SublotRowId',
            loadMode: 'raw',
            load: async () => {
                if (!props.ItemId) {
                    loadedRows.current = [];
                    return loadedRows.current;
                }
                const response = await fetch(
                    `${window._env_.REACT_APP_APIS}/wm/ItemLotSublotUnion/GetWMItemsLotSublotUnion?ItemRowId=${props.ItemId}&ShipDate=${shipDate}`,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );
                if (!response.ok) throw new Error(MESSAGES.ERROR);
                // The endpoint answers with a DataSourceLoadResult, so the rows are under .data.
                const body = await response.json();
                loadedRows.current = Array.isArray(body?.data) ? body.data : [];
                return loadedRows.current;
            },
            // REQUIRED, even though nothing is persisted per row. The Ship Quantity column is
            // editable (Editing mode="batch" allowUpdating), and handelOkClick calls saveEditData(),
            // which routes every batch change through the store's update. A CustomStore without it
            // throws "E4011 - Custom Store method is not implemented or is not a function: update"
            // the moment OK is pressed; the plain array binding used to absorb this silently.
            //
            // The edit is local by design: the picked rows are posted in ONE request by
            // handelOkClick (ApplyManualSublotAndLotSelection), never row by row. So update only has
            // to accept the change and patch the cached row, which is what keeps
            // getSelectedRowsData() returning the typed Ship Quantity afterwards.
            update: (key, values) => {
                const row = loadedRows.current.find((r) => r.SublotRowId === key);
                if (row) Object.assign(row, values);
                return Promise.resolve(values);
            },
            // Optional per the CustomStore docs, but DevExtreme calls it to fetch a single record and
            // does so "commonly during editing". Served from the rows already in hand rather than
            // re-querying, so a missing byKey cannot become the next E4011.
            byKey: (key) => Promise.resolve(
                loadedRows.current.find((r) => r.SublotRowId === key)
            ),
        }),
    }), [props.ItemId, shipDate, accessToken]);

    const handleFormLoad = useCallback(() => {
    }, []);

    const handleFieldChange = useCallback((name, value) => {

    }, []);


    return (
        <div>
             <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={showIndicator}
                shading={shading}
                showPane={showPane}
                hideOnOutsideClick={hideOnOutsideClick}
            />
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <AccordionReact
                            dataSource={searchpanel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={e => {
                                if (e.currentTarget === e.target) {
                                    selectionChanged(e, e.target);
                                }
                            }}
                            itemTitleRender={() => (
                                <></>
                            )}
                            itemRender={(itemProps) => (
                                <FormField
                                    currrentUser={currentUser}
                                    layoutId='f1620480-0d5e-4657-b372-0a6a6c56f387'
                                    layoutName='ManuallySelectSublotsAndLotsForShipmentForm'
                                    defaultFormSchema={[
                                        {
                                            "groupId": 1,
                                            "fields": [
                                                {
                                                    "name": "ItemCode",
                                                    "tableName": "IMITEM",
                                                    "label": "Item Code",
                                                    "type": "text",
                                                    "required": false,
                                                    "visible": true,
                                                    "isLabelChanged": false,
                                                    "readOnly": true,
                                                }]
                                        },
                                        {
                                            "groupId": 2,
                                            "fields": [
                                                {
                                                    "name": "ItemType",
                                                    "tableName": "IMITEM",
                                                    "label": "Item Type",
                                                    "type": "text",
                                                    "required": false,
                                                    "visible": true,
                                                    "isLabelChanged": false,
                                                    "readOnly": true,
                                                }
                                            ]
                                        },
                                        {
                                            "groupId": 3,
                                            "fields": [
                                                {
                                                    "name": "TotalQuantity",
                                                    "tableName": "IMLOT",
                                                    "label": "Total Quantity",
                                                    "type": "number",
                                                    "format": "#,###0.00",
                                                    "required": false,
                                                    "visible": true,
                                                    "isLabelChanged": false,
                                                    "readOnly": true,
                                                }
                                            ]
                                        },
                                        {
                                            "groupId": 4,
                                            "fields": [
                                                {
                                                    "name": "TotalNetWeight",
                                                    "tableName": "IMLOT",
                                                    "label": "Total Net Weight",
                                                    "format": "#,###0.00",
                                                    "type": "number",
                                                    "required": false,
                                                    "visible": true,
                                                    "isLabelChanged": false,
                                                    "readOnly": true,
                                                }
                                            ]
                                        }]}
                                    formFields={formFields}
                                    setformFields={setformFields}
                                    handleFieldValueChange={handleFieldChange}
                                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                    formRefs={formRefs}
                                    onFormLoad={handleFormLoad}
                                    noSpacingBeforeFirstRow={true}
                                />
                            )}
                            id="accordion-container" className="accordion-height"
                        />
                        <DataGrid

                    onExporting={(e) => {
                                if (window.handleDevExtremeDataGridExport) {
                                    window.handleDevExtremeDataGridExport(e);
                                }
                            }}
                            ref={dataGrid}
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            dataSource={sublotDataSource}
                            // No keyExpr here on purpose: it is only applied when dataSource is an
                            // array, and DevExtreme warns when it is set alongside a store. The key
                            // comes from the CustomStore above.
                            showBorders={true}
                            hoverStateEnabled={true}
                            className={"GridHeightAccordianOpen-tabs-single-row"}
                            onSelectionChanged={(e) => onSelectionChanged(e)}
                            searchEnabled={true}
                            columnAutoWidth={true}
                        >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <Editing
                                mode="batch"
                                allowUpdating={true}
                                allowAdding={false}
                                allowDeleting={false}
                            />
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="multiple" />
                            <Sorting visible={true} mode="multiple" />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            {/* <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            /> */}
                            <FilterRow visible={true} />
                            <Column dataField="SublotRowId" caption="Rowid" dataType="string" visible={false} allowEditing={false}/>
                            <Column dataField="LotCode" caption="Lot Code" dataType="string" allowEditing={false} sortIndex={0} sortOrder="asc"/>
                            <Column dataField="LotDescription1" caption="Lot Description" dataType="string" allowEditing={false}/>
                            <Column dataField="ClassCodeLot" caption="Lot Class" dataType="string" allowEditing={false}/>
                            <Column dataField="SubclassCode" caption="Lot SubClass" dataType="string" allowEditing={false}/>
                            <Column dataField="SublotCode" caption="Sublot Code" dataType="string" allowEditing={false}/>
                            <Column dataField="SublotDescription1" caption="Sublot Description" dataType="string" allowEditing={false}/>
                            <Column dataField="DateAvailableSublot" caption="Available Date" dataType="datetime" allowEditing={false}/>
                            <Column dataField="DateExpirationSublot" caption="Expiration Date" dataType="datetime" allowEditing={false}/>
                            <Column dataField="WarehouseIdentityId" caption="Warehouse" dataType="string" allowEditing={false}/>
                            <Column dataField="SublotConsignee" caption="Consignee" dataType="string" allowEditing={false}/>
                            <Column dataField="LocationCode" caption="Location" dataType="string" allowEditing={false}/>
                            <Column dataField="NetWeightQuantitySublot" caption="Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} allowEditing={false}/>
                            <Column dataField="SublotAvailable" caption="Available" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} allowEditing={false}/>
                            <Column dataField="TransferQuantity" caption="Ship Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} allowEditing={true}
                                setCellValue={(newData, value, currentRowData) => {
                                    // Delphi warns and then clamps the entry back to Available - it does
                                    // not just drop the edit (uWMD0109.pas:404-408). Returning without
                                    // assigning left the cell on its previous value.
                                    if (value > currentRowData.SublotAvailable) {
                                        alert(MESSAGES.ACTUAL_QUANTITY_GREATER_THEN_AVAILABLE, MESSAGES.ERROR);
                                        newData.TransferQuantity = currentRowData.SublotAvailable;
                                        return;
                                    }
                                    newData.TransferQuantity = value;
                                    calculateWeights(selectedRows);
                                }} />
                            <Column dataField="OnHandSublot" caption="On Hand" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} allowEditing={false}/>
                            <GridToolbar>
{/*                                 <GridToolbarItem location="after">
                                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem> */}
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                        </DataGrid>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', minHeight:"30px" }}>
                            <Button
                                text="OK"
                                type="default"
                                disabled={!(selectedRows && selectedRows.length > 0)}
                                onClick={handelOkClick}
                                style={{ marginRight: '10px' }}
                            />
                            <Button
                                text="Cancel"
                                onClick={props.CloseManuallySelectSublotsAndLotsForShipmentScreen}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(ManuallySelectSublotsAndLotsForShipment);